const translations = {
  en: {
    subtitle: 'A personal recipe collection',
    signIn: 'Sign in',
    signOut: 'Sign out',
    searchPlaceholder: 'Search recipes by name or ingredient…',
    searching: 'Searching…',
    noRecipesFound: (q) => `No recipes found for "${q}"`,
    oneRecipeFound: (q) => `1 recipe found for "${q}"`,
    recipesFound: (n, q) => `${n} recipes found for "${q}"`,
    noRecipesYet: 'No recipes yet',
    oneRecipe: '1 recipe',
    nRecipes: (n) => `${n} recipes`,
    categories: { 'Main Course': 'Main Course', 'Soup': 'Soup', 'Dessert': 'Dessert', 'Baking': 'Baking', 'Breakfast': 'Breakfast', 'Starters': 'Starters', 'Side Dishes': 'Side Dishes' },
    cuisines: { 'British': 'British', 'Italian': 'Italian', 'French': 'French', 'American': 'American', 'Mexican': 'Mexican', 'Chinese': 'Chinese', 'Indian': 'Indian', 'Japanese': 'Japanese', 'Thai': 'Thai', 'Greek': 'Greek', 'Spanish': 'Spanish', 'Turkish': 'Turkish', 'Hungarian': 'Hungarian', 'German': 'German', 'Lebanese': 'Lebanese', 'Mediterranean': 'Mediterranean', 'Asian': 'Asian', 'Middle Eastern': 'Middle Eastern' },
    dietaryTags: { 'vegetarian': 'vegetarian', 'vegan': 'vegan', 'gluten-free': 'gluten-free', 'dairy-free': 'dairy-free', 'nut-free': 'nut-free', 'egg-free': 'egg-free', 'low-carb': 'low-carb', 'keto': 'keto', 'halal': 'halal', 'kosher': 'kosher', 'paleo': 'paleo' },
    allRecipes: 'All Recipes',
    allCategories: '← All categories',
    noRecipesInCategory: 'No recipes in this category yet.',
    loading: 'Loading…',
    difficulty: { easy: 'Easy', medium: 'Medium', hard: 'Hard' },
    backToRecipes: '← Back to recipes',
    totalTime: 'Total time',
    serves: 'Serves',
    metric: 'Metric',
    imperial: 'Imperial',
    ingredients: 'Ingredients',
    scaledFor: (n, unit) => `Scaled for ${n} ${unit}`,
    instructions: 'Instructions',
    nutritionTitle: 'Nutrition',
    perServing: 'per serving',
    protein: 'protein',
    carbs: 'carbs',
    fat: 'fat',
    fiber: 'fiber',
    sugar: 'sugar',
    equipmentNeeded: 'Equipment needed',
    notesHeading: "Cook's notes",
    storage: 'Storage',
    tipsTitle: 'AI Tips & Tricks',
    recipeFrom: 'Recipe from',
    adaptedFrom: 'Adapted from',
    adaptedRecipe: 'Adapted recipe',
    loadingRecipe: 'Loading recipe…',
    recipeNotFound: 'Recipe not found.',
    editRecipe: 'Edit recipe',
    deleteRecipe: 'Delete',
    deleteConfirm: 'Delete this recipe?',
    yesDelete: 'Yes, delete',
    cancel: 'Cancel',
    deleting: 'Deleting…',
    generateTips: '✨ Generate tips with Claude',
    generatingTips: 'Generating tips…',
    translateToHungarian: '🇭🇺 Translate to Hungarian',
    addToShoppingList: 'Add to shopping list',
    addingToList: 'Adding…',
    addedToList: '✓ Added',
    home: 'Home',
    navMeals: 'Meals',
    navShopping: 'Shopping',
    navCollections: 'Collections',
    navExport: 'Export',
    shoppingList: 'Shopping list',
    mealPlan: 'Meal plan',
    mealPlanTitle: 'Weekly Meal Plan',
    mealPlanBreakfast: 'Breakfast',
    mealPlanLunch: 'Lunch',
    mealPlanDinner: 'Dinner',
    mealPlanEmpty: '+ Add recipe',
    mealPlanSearchPlaceholder: 'Search recipes…',
    mealPlanNoResults: 'No recipes found',
    mealPlanGenerateShopping: 'Add week to shopping list',
    mealPlanGenerating: 'Adding…',
    mealPlanAdded: '✓ Added to shopping list',
    mealPlanNothingPlanned: 'No recipes planned this week.',
    mealPlanClearSlot: 'Remove',
    mealPlanLoading: 'Loading meal plan…',
    mealPlanWeekOf: (d) => `Week of ${d}`,
    mealPlanDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    addToMealPlan: 'Add to meal plan',
    mealPlanModalTitle: 'Add to meal plan',
    mealPlanSlotAdded: '✓ Added',
    mealPlanSlotRemoved: 'Removed',
    mealPlanReplaceSlot: 'Replace?',
    shoppingListEmpty: 'Your shopping list is empty.',
    shoppingListHint: 'Open a recipe and tap "Add to shopping list" to get started.',
    shoppingItemsRemaining: (n) => `${n} item${n === 1 ? '' : 's'} remaining`,
    shoppingAllDone: 'All done — enjoy your shop!',
    clearChecked: 'Clear checked',
    clearAll: 'Clear all',
    foodGroups: { 'Vegetables & Fruit': 'Vegetables & Fruit', 'Meat & Fish': 'Meat & Fish', 'Dairy & Eggs': 'Dairy & Eggs', 'Bakery': 'Bakery', 'Pantry': 'Pantry', 'Other': 'Other' },
    translating: 'Translating…',
    translationMissing: 'No Hungarian translation yet.',
    ebookTitle: 'Export PDF Cookbook',
    ebookDesc: 'Export all your recipes as a beautifully formatted PDF cookbook, with a cover page, table of contents, and one page per recipe.',
    ebookLanguage: 'Language',
    ebookGenerate: 'Generate & Download PDF',
    ebookGeneratingSub: 'This may take 15–30 seconds…',
    ebookLoadingLibrary: 'Loading PDF library…',
    ebookFetchingRecipes: 'Fetching recipes…',
    ebookFetchingTranslations: 'Fetching translations…',
    ebookLoadingImages: 'Loading images…',
    ebookGenerating: 'Generating PDF…',
    ebookDone: 'Your PDF has been downloaded!',
    ebookClose: 'Close',
    ebookError: 'Something went wrong generating the PDF.',
    exportCookbook: 'Export cookbook',
    aboutLink: 'About',
    about: {
      title: 'About Solt Pantry',
      subtitle: 'A personal recipe collection made with love, by a Hungarian in England.',
      quote: 'I am no chef — and if you ask my partner, he will tell you he is the better cook. But this little corner of the internet is mine, and I am proud of it.',
      whyHeading: 'Why I made this',
      whyBody: 'I am Hungarian, living in England, and I needed somewhere to keep my recipes. Not restaurant recipes or chef recipes — just the kind of food that gets made in real kitchens, on real weeknights, by real people who are not especially gifted cooks (hello). Mainly Hungarian and English dishes, nothing too complicated, nothing that requires skills I do not have.',
      whatHeading: 'What you\'ll find here',
      whatBody: 'Three kinds of recipes, really. The gems — recipes handed to me by my mum, my friends, their mums, the kind that have been made in households for years and years. The regulars — dishes I make every week and keep tweaking until they are just right. And the new ones — recipes I find on websites, in books, or that someone scribbles on a piece of paper and hands to me. I try them, I keep the ones I love. Time to time I also go on a health kick, so you might find the odd keto or lighter recipe creeping in.',
      whoHeading: 'What this means to me',
      whoBody: 'As a Hungarian living in England, being able to make the dishes I grew up with helps with the homesickness. It keeps me close to my mum\'s kitchen, even from a distance. My partner is English, and I want to do the same for him — take the recipes his nan makes and keep them safe too. Food is memory. This is my way of keeping it.',
      hopeHeading: 'If you have stumbled on this',
      hopeBody: 'This is a personal hobby, made for me and my family. But if you have found your way here, you are welcome. Use whatever you like. I hope something here makes its way into your kitchen too.',
    },
    favourites: 'Favourites',
    favouritesOnly: 'Favourites only',
    noFavourites: 'No favourites yet. Click the ♥ on any recipe to save it here.',
    myPicks: 'My Picks',
    noMyPicks: 'No saved recipes yet. Click ♥ on any recipe to save it here.',
    sortLabel: 'Sort:',
    sortAZ: 'A–Z',
    sortZA: 'Z–A',
    sortQuickest: 'Quickest first',
    sortNewest: 'Newest first',
    filterDifficulty: 'All difficulties',
    filterUnder30: '< 30 min',
    filter60Plus: '60 min+',
    filterVegetarian: 'Vegetarian',
    filterLowCarb: 'Low carb',
    noRecipesMatchFilters: 'No recipes match your filters.',
    clearFilters: 'Clear filters',
    traditional: 'Traditional',
    traditionalTooltip: 'Traditional / authentic recipe',
    labelTraditional: 'Traditional recipe',
    traditionalHint: 'Mark this as a traditional or authentic recipe',
    filterEasy: 'Easy',
    filterMedium: 'Medium',
    filterHard: 'Hard',
    collectionsTitle: 'Collections',
    collectionsEmpty: 'No collections yet.',
    collectionsLink: 'Collections',
    newCollection: '+ New collection',
    collectionNamePlaceholder: 'e.g. Weeknight dinners',
    createCollection: 'Create',
    deleteCollection: 'Delete',
    deleteCollectionConfirm: 'Delete this collection? Recipes will not be deleted.',
    addToCollection: 'Add to collection',
    collectionEmpty: 'No recipes in this collection yet.',
    shareRecipe: 'Copy link',
    shareRecipeCopied: 'Copied!',
    startCooking: 'Start cooking',
    cookingModeIngredients: 'Ingredients',
    cookingModeSteps: 'Steps',
    cookingModeStepOf: (current, total) => `Step ${current} of ${total}`,
    cookingModeStartTimer: 'Start timer',
    cookingModePauseTimer: 'Pause',
    cookingModeResetTimer: 'Reset',
    cookingModePrev: '← Prev',
    cookingModeNext: 'Next →',
    cookingModeFinish: '🎉 Finished!',
    cookingModeClose: '✕ Exit cooking mode',
    cookingModeDone: "You're done! Enjoy your meal.",
    cookingNotesTitle: "My cooking notes",
    cookingNotesPlaceholder: "e.g. Made this 3 Jan — sauce was too salty, reduce by half next time…",
    cookingNotesSave: 'Save note',
    cookingNotesSaving: 'Saving…',
    cookingNotesEmpty: 'No notes yet. Add your first cooking note above.',
    cookingNotesEdit: 'Edit',
    cookingNotesDelete: 'Delete',
    loginTitle: 'Sign in to Solt Pantry',
    loginSubtitle: 'Enter your email to receive a magic link.',
    emailLabel: 'Email address',
    sendMagicLink: 'Send magic link',
    sending: 'Sending…',
    checkEmail: "Check your email — we've sent you a sign-in link.",
    loginError: 'Something went wrong. Please try again.',
    backToHome: '← Back to recipes',
    importPanel: {
      titleChoose: 'Add Recipe', titleUrl: 'Import from URL', titleYoutube: 'Import from YouTube', titlePaste: 'Paste Recipe Text', titlePhoto: 'Upload a Photo', titleFile: 'Upload a PDF', titleLoading: 'Working…', titlePreview: 'Review Recipe',
      optionUrl: 'Import from URL', optionYoutube: 'Import from YouTube', optionPhoto: 'Upload a photo', optionFile: 'Upload a PDF', optionPaste: 'Paste recipe text', optionManual: 'Add manually',
      back: 'Back', fetchRecipe: 'Fetch Recipe', extractRecipe: 'Extract Recipe', structureRecipe: 'Structure Recipe', readPhoto: 'Read Photo', readPdf: 'Read PDF', saveRecipe: 'Save Recipe', saving: 'Saving…',
      photoZonePrompt: 'Click to choose a photo, or drag and drop', photoZoneHint: 'JPEG, PNG, or WebP — max 4.5 MB',
      pdfZonePrompt: 'Click to choose a PDF, or drag and drop', pdfZoneHint: 'PDF only — max 4.5 MB',
      loadingUrl: 'Fetching page and extracting recipe…', loadingYoutube: 'Fetching video transcript and extracting recipe…', loadingPaste: 'Structuring your recipe…', loadingPhoto: 'Reading your photo and extracting recipe…', loadingFile: 'Reading your document and extracting recipe…', loadingSub: 'This takes about 10–20 seconds.',
      sectionBasic: 'Basic info', sectionIngredients: 'Ingredients', sectionSteps: 'Steps', sectionTags: 'Tags & extras', sectionNutrition: 'Nutrition', sectionNutritionSub: 'per serving — optional', sectionImage: 'Image & source',
      labelTitle: 'Title *', labelDescription: 'Description', labelCategory: 'Category', labelCuisine: 'Cuisine', labelDifficulty: 'Difficulty', labelPrepTime: 'Prep time (mins)', labelCookTime: 'Cook time (mins)', labelServings: 'Servings', labelServingsUnit: 'Servings unit',
      labelAmount: 'Amount', labelUnit: 'Unit', labelIngredient: 'Ingredient', labelPrepNotes: 'Prep notes', labelDietaryTags: 'Dietary tags', labelEquipment: 'Equipment', labelNotes: 'Notes', labelStorage: 'Storage instructions',
      labelCalories: 'Calories (kcal)', labelProtein: 'Protein (g)', labelCarbs: 'Carbs (g)', labelFat: 'Fat (g)', labelFibre: 'Fibre (g)', labelSugar: 'Sugar (g)', labelSodium: 'Sodium (mg)',
      labelImage: 'Image', labelOrPasteUrl: 'Or paste a URL', labelSource: 'Source',
      placeholderCuisine: 'e.g. British, Italian', placeholderServingsUnit: 'servings', placeholderIngredient: 'ingredient', placeholderPrepNotes: 'e.g. finely chopped', placeholderStepInstruction: 'Step instruction…', placeholderMins: 'mins',
      placeholderEquipment: 'Add equipment and press Enter…', placeholderNotes: 'Any extra tips or notes…', placeholderStorage: 'e.g. Keeps in the fridge for 3 days…', placeholderImageUrl: 'https://…',
      placeholderSource: "e.g. BBC Good Food, Mum's cookbook, Jamie's Italy p.45",
      placeholderPasteText: "Paste your recipe text here…\n\ne.g. Mum's chocolate cake\n2 cups flour, 1 cup sugar, 3 eggs…\nMix dry ingredients, add eggs…",
      placeholderTagInput: 'Type a tag and press Enter…',
      difficultyEasy: 'Easy', difficultyMedium: 'Medium', difficultyHard: 'Hard',
      addIngredient: '+ Add ingredient', addStep: '+ Add step',
      pantryStaples: (items) => `🥄 Pantry staples detected: ${items} — these will be hidden from your shopping list by default.`,
      errorTitleRequired: 'Title is required.', errorNetwork: 'Network error — please check your connection and try again.', errorUrl: 'Something went wrong. Please try a different URL.',
      errorYoutube: 'Could not extract a recipe from this video.', errorPaste: 'Could not structure this recipe. Please check the text and try again.',
      errorFileSize: 'File is too large. Please use a file under 4.5 MB.', errorFile: 'Could not extract a recipe from this file.',
      errorDropImage: 'Please drop an image file (JPEG, PNG, or WebP).', errorDropPdf: 'Please drop a PDF file.', minsLabel: 'mins',
    },
  },

  hu: {
    subtitle: 'Személyes receptgyűjtemény',
    signIn: 'Bejelentkezés',
    signOut: 'Kijelentkezés',
    searchPlaceholder: 'Keresés recept neve vagy hozzávaló alapján…',
    searching: 'Keresés…',
    noRecipesFound: (q) => `Nem található recept: „${q}"`,
    oneRecipeFound: (q) => `1 recept találat: „${q}"`,
    recipesFound: (n, q) => `${n} recept találat: „${q}"`,
    noRecipesYet: 'Még nincs recept',
    oneRecipe: '1 recept',
    nRecipes: (n) => `${n} recept`,
    categories: { 'Main Course': 'Főételek', 'Soup': 'Levesek', 'Dessert': 'Desszertek', 'Baking': 'Sütés', 'Breakfast': 'Reggeli', 'Starters': 'Előételek', 'Side Dishes': 'Köretek' },
    cuisines: { 'British': 'Brit', 'Italian': 'Olasz', 'French': 'Francia', 'American': 'Amerikai', 'Mexican': 'Mexikói', 'Chinese': 'Kínai', 'Indian': 'Indiai', 'Japanese': 'Japán', 'Thai': 'Thai', 'Greek': 'Görög', 'Spanish': 'Spanyol', 'Turkish': 'Török', 'Hungarian': 'Magyar', 'German': 'Német', 'Lebanese': 'Libanoni', 'Mediterranean': 'Mediterrán', 'Asian': 'Ázsiai', 'Middle Eastern': 'Közel-keleti' },
    dietaryTags: { 'vegetarian': 'vegetáriánus', 'vegan': 'vegán', 'gluten-free': 'gluténmentes', 'dairy-free': 'tejtermékektől mentes', 'nut-free': 'diómentes', 'egg-free': 'tojásmentes', 'low-carb': 'alacsony szénhidráttartalmú', 'keto': 'keto', 'halal': 'halal', 'kosher': 'kóser', 'paleo': 'paleo' },
    allRecipes: 'Összes recept',
    allCategories: '← Minden kategória',
    noRecipesInCategory: 'Ebben a kategóriában még nincs recept.',
    loading: 'Betöltés…',
    difficulty: { easy: 'Könnyű', medium: 'Közepes', hard: 'Nehéz' },
    backToRecipes: '← Vissza a receptekhez',
    totalTime: 'Teljes idő',
    serves: 'Adag',
    metric: 'Metrikus',
    imperial: 'Angolszász',
    ingredients: 'Hozzávalók',
    scaledFor: (n, unit) => `${n} ${unit} arányában`,
    instructions: 'Elkészítés',
    nutritionTitle: 'Tápértékek',
    perServing: 'adagonként',
    protein: 'fehérje',
    carbs: 'szénhidrát',
    fat: 'zsír',
    fiber: 'rost',
    sugar: 'cukor',
    equipmentNeeded: 'Szükséges eszközök',
    notesHeading: 'Megjegyzések',
    storage: 'Tárolás',
    tipsTitle: 'AI tippek és trükkök',
    recipeFrom: 'Recept forrása',
    adaptedFrom: 'Adaptálva innen',
    adaptedRecipe: 'Adaptált recept',
    loadingRecipe: 'Recept betöltése…',
    recipeNotFound: 'A recept nem található.',
    editRecipe: 'Recept szerkesztése',
    deleteRecipe: 'Törlés',
    deleteConfirm: 'Törli ezt a receptet?',
    yesDelete: 'Igen, törlés',
    cancel: 'Mégsem',
    deleting: 'Törlés…',
    generateTips: '✨ Tippek generálása',
    generatingTips: 'Tippek generálása…',
    translateToHungarian: '🇭🇺 Magyar fordítás',
    addToShoppingList: 'Bevásárlólistához adás',
    addingToList: 'Hozzáadás…',
    addedToList: '✓ Hozzáadva',
    home: 'Főoldal',
    navMeals: 'Terv',
    navShopping: 'Bevásárlás',
    navCollections: 'Gyűjtemények',
    navExport: 'Export',
    shoppingList: 'Bevásárlólista',
    mealPlan: 'Heti terv',
    mealPlanTitle: 'Heti étkezési terv',
    mealPlanBreakfast: 'Reggeli',
    mealPlanLunch: 'Ebéd',
    mealPlanDinner: 'Vacsora',
    mealPlanEmpty: '+ Recept hozzáadása',
    mealPlanSearchPlaceholder: 'Recept keresése…',
    mealPlanNoResults: 'Nem található recept',
    mealPlanGenerateShopping: 'Hét hozzáadása a bevásárlólistához',
    mealPlanGenerating: 'Hozzáadás…',
    mealPlanAdded: '✓ Hozzáadva a bevásárlólistához',
    mealPlanNothingPlanned: 'Erre a hétre nincs tervezett recept.',
    mealPlanClearSlot: 'Törlés',
    mealPlanLoading: 'Heti terv betöltése…',
    mealPlanWeekOf: (d) => `Hét: ${d}`,
    mealPlanDays: ['H', 'K', 'Sze', 'Cs', 'P', 'Szo', 'V'],
    addToMealPlan: 'Heti tervhez adás',
    mealPlanModalTitle: 'Heti tervhez adás',
    mealPlanSlotAdded: '✓ Hozzáadva',
    mealPlanSlotRemoved: 'Törölve',
    mealPlanReplaceSlot: 'Felülírja?',
    shoppingListEmpty: 'A bevásárlólistád üres.',
    shoppingListHint: 'Nyiss meg egy receptet, és kattints a „Bevásárlólistához adás" gombra.',
    shoppingItemsRemaining: (n) => `${n} tétel van még hátra`,
    shoppingAllDone: 'Minden megvan — jó bevásárlást!',
    clearChecked: 'Kipipáltak törlése',
    clearAll: 'Összes törlése',
    foodGroups: { 'Vegetables & Fruit': 'Zöldség és gyümölcs', 'Meat & Fish': 'Hús és hal', 'Dairy & Eggs': 'Tejtermék és tojás', 'Bakery': 'Pékáru', 'Pantry': 'Kamra', 'Other': 'Egyéb' },
    translating: 'Fordítás…',
    translationMissing: 'Még nincs magyar fordítás.',
    ebookTitle: 'PDF receptkönyv exportálása',
    ebookDesc: 'Exportálja az összes receptjét szépen formázott PDF receptkönyvbe, borítóoldallal, tartalomjegyzékkel és oldalanként egy recepttel.',
    ebookLanguage: 'Nyelv',
    ebookGenerate: 'PDF létrehozása és letöltése',
    ebookGeneratingSub: 'Ez 15–30 másodpercig tarthat…',
    ebookLoadingLibrary: 'PDF könyvtár betöltése…',
    ebookFetchingRecipes: 'Receptek betöltése…',
    ebookFetchingTranslations: 'Fordítások betöltése…',
    ebookLoadingImages: 'Képek betöltése…',
    ebookGenerating: 'PDF generálása…',
    ebookDone: 'A PDF letöltése megkezdődött!',
    ebookClose: 'Bezárás',
    ebookError: 'Hiba történt a PDF generálása során.',
    exportCookbook: 'Receptkönyv exportálása',
    aboutLink: 'Rólam',
    about: {
      title: 'A Solt Pantryről',
      subtitle: 'Egy személyes receptgyűjtemény szeretettel összerakva, egy Angliában élő magyartól.',
      quote: 'Nem vagyok séf — és ha megkérdezed a páromat, ő azt fogja mondani, hogy ő a jobb szakács. De ez az én kis sarkom az interneten, és büszke vagyok rá.',
      whyHeading: 'Miért csináltam ezt az oldalt',
      whyBody: 'Magyar vagyok, Angliában élek, és szükségem volt egy helyre, ahol tárolhatom a receptjeimet. Nem éttermi vagy séfes receptek — csak olyan ételek, amelyeket igazi konyhákban főznek, igazi hétköznapokon, igazi emberek, akik nem különösebben tehetséges szakácsok (helló). Főleg magyar és angol ételek, semmi túl bonyolult, semmi ami különleges tudást igényelne.',
      whatHeading: 'Mit találsz itt',
      whatBody: 'Háromféle recept, igazából. A kincsek — receptek, amelyeket anyukámtól, barátaimtól, azok anyukájától kaptam, amelyeket évek, sőt évtizedek óta főznek otthon. A rendszeresek — ételek, amelyeket minden héten főzök és folyamatosan tökéletesítek. És az újak — receptek, amelyeket weboldalon, könyvben találok, vagy valaki ír le egy papírra és ad oda. Kipróbálom, megtartom, amit szeretek. Időnként egészségkickre is kerül sor, szóval néha keto vagy könnyebb receptek is feltűnhetnek.',
      whoHeading: 'Mit jelent ez nekem',
      whoBody: 'Angliában élő magyarként az itthon ízei segítenek a honvágyban. Közel tartanak anyukám konyhájához, még ha messziről is. A párom angol, és ugyanezt szeretném megtenni neki is — megőrizni azokat a recepteket, amelyeket a nagymamája főz. Az étel emlék. Ez az én módszerem arra, hogy életben tartsam.',
      hopeHeading: 'Ha véletlenül ide tévedtél',
      hopeBody: 'Ez egy személyes hobbi, magamnak és a családomnak csináltam. De ha idetaláltál, szívesen látlak. Használj bármit, amit szeretnél. Remélem, valami innen utat talál a te konyhádba is.',
    },
    favourites: 'Kedvencek',
    favouritesOnly: 'Csak kedvencek',
    noFavourites: 'Még nincs kedvenc. Kattints a ♥ gombra bármely recepten.',
    myPicks: 'Mentett receptek',
    noMyPicks: 'Még nincs mentett recept. Kattints a ♥ gombra bármely recepten.',
    sortLabel: 'Rendezés:',
    sortAZ: 'A–Z',
    sortZA: 'Z–A',
    sortQuickest: 'Leggyorsabb',
    sortNewest: 'Legújabb',
    filterDifficulty: 'Minden nehézség',
    filterUnder30: '< 30 perc',
    filter60Plus: '60 perc+',
    filterVegetarian: 'Vegetáriánus',
    filterLowCarb: 'Kevés szénhidrát',
    noRecipesMatchFilters: 'Nincs ilyen recept.',
    clearFilters: 'Szűrők törlése',
    traditional: 'Hagyományos',
    traditionalTooltip: 'Hagyományos / eredeti recept',
    labelTraditional: 'Hagyományos recept',
    traditionalHint: 'Jelöld meg hagyományos vagy eredeti receptként',
    filterEasy: 'Könnyű',
    filterMedium: 'Közepes',
    filterHard: 'Nehéz',
    collectionsTitle: 'Gyűjtemények',
    collectionsEmpty: 'Még nincs gyűjtemény.',
    collectionsLink: 'Gyűjtemények',
    newCollection: '+ Új gyűjtemény',
    collectionNamePlaceholder: 'pl. Hétköznapi vacsorák',
    createCollection: 'Létrehozás',
    deleteCollection: 'Törlés',
    deleteCollectionConfirm: 'Törli ezt a gyűjteményt? A receptek nem törlődnek.',
    addToCollection: 'Gyűjteményhez adás',
    collectionEmpty: 'Ebben a gyűjteményben még nincs recept.',
    shareRecipe: 'Link másolása',
    shareRecipeCopied: 'Másolva!',
    startCooking: 'Főzés elkezdése',
    cookingModeIngredients: 'Hozzávalók',
    cookingModeSteps: 'Lépések',
    cookingModeStepOf: (current, total) => `${current}. lépés / ${total}`,
    cookingModeStartTimer: 'Időzítő indítása',
    cookingModePauseTimer: 'Szünet',
    cookingModeResetTimer: 'Visszaállítás',
    cookingModePrev: '← Előző',
    cookingModeNext: 'Következő →',
    cookingModeFinish: '🎉 Kész!',
    cookingModeClose: '✕ Kilépés',
    cookingModeDone: 'Kész! Jó étvágyat!',
    cookingNotesTitle: 'Főzési naplóm',
    cookingNotesPlaceholder: 'pl. Elkészítettem jan. 3-án — a szósz túl sós volt, legközelebb felezem a mennyiséget…',
    cookingNotesSave: 'Mentés',
    cookingNotesSaving: 'Mentés…',
    cookingNotesEmpty: 'Még nincs bejegyzés. Adj hozzá az első főzési naplóbejegyzést fent.',
    cookingNotesEdit: 'Szerkesztés',
    cookingNotesDelete: 'Törlés',
    loginTitle: 'Bejelentkezés a Solt Pantry-ba',
    loginSubtitle: 'Add meg az e-mail-címedet, és küldünk egy belépési linket.',
    emailLabel: 'E-mail-cím',
    sendMagicLink: 'Belépési link küldése',
    sending: 'Küldés…',
    checkEmail: 'Ellenőrizd az e-mailjeidet — küldtünk egy belépési linket.',
    loginError: 'Valami hiba történt. Kérjük, próbáld újra.',
    backToHome: '← Vissza a receptekhez',
    importPanel: {
      titleChoose: 'Recept hozzáadása', titleUrl: 'Importálás URL-ről', titleYoutube: 'Importálás YouTube-ről', titlePaste: 'Szöveg beillesztése', titlePhoto: 'Fotó feltöltése', titleFile: 'PDF feltöltése', titleLoading: 'Feldolgozás…', titlePreview: 'Recept áttekintése',
      optionUrl: 'Importálás URL-ről', optionYoutube: 'Importálás YouTube-ről', optionPhoto: 'Fotó feltöltése', optionFile: 'PDF feltöltése', optionPaste: 'Szöveg beillesztése', optionManual: 'Kézi bevitel',
      back: 'Vissza', fetchRecipe: 'Recept letöltése', extractRecipe: 'Recept kinyerése', structureRecipe: 'Recept rendszerezése', readPhoto: 'Fotó beolvasása', readPdf: 'PDF beolvasása', saveRecipe: 'Recept mentése', saving: 'Mentés…',
      photoZonePrompt: 'Kattints a fotó kiválasztásához, vagy húzd ide', photoZoneHint: 'JPEG, PNG vagy WebP – max. 4,5 MB',
      pdfZonePrompt: 'Kattints a PDF kiválasztásához, vagy húzd ide', pdfZoneHint: 'Csak PDF – max. 4,5 MB',
      loadingUrl: 'Oldal letöltése és recept kinyerése…', loadingYoutube: 'Felirat letöltése és recept kinyerése…', loadingPaste: 'Recept rendszerezése…', loadingPhoto: 'Fotó beolvasása és recept kinyerése…', loadingFile: 'Dokumentum beolvasása és recept kinyerése…', loadingSub: 'Ez körülbelül 10–20 másodpercet vesz igénybe.',
      sectionBasic: 'Alapadatok', sectionIngredients: 'Hozzávalók', sectionSteps: 'Elkészítés', sectionTags: 'Címkék és egyéb', sectionNutrition: 'Tápértékek', sectionNutritionSub: 'adagonként – opcionális', sectionImage: 'Kép és forrás',
      labelTitle: 'Cím *', labelDescription: 'Leírás', labelCategory: 'Kategória', labelCuisine: 'Konyha', labelDifficulty: 'Nehézség', labelPrepTime: 'Előkészítési idő (perc)', labelCookTime: 'Főzési idő (perc)', labelServings: 'Adag', labelServingsUnit: 'Adagolás mértéke',
      labelAmount: 'Mennyiség', labelUnit: 'Mértékegység', labelIngredient: 'Hozzávaló', labelPrepNotes: 'Megjegyzés', labelDietaryTags: 'Étkezési címkék', labelEquipment: 'Eszközök', labelNotes: 'Megjegyzések', labelStorage: 'Tárolási útmutató',
      labelCalories: 'Kalória (kcal)', labelProtein: 'Fehérje (g)', labelCarbs: 'Szénhidrát (g)', labelFat: 'Zsír (g)', labelFibre: 'Rost (g)', labelSugar: 'Cukor (g)', labelSodium: 'Nátrium (mg)',
      labelImage: 'Kép', labelOrPasteUrl: 'Vagy illeszd be az URL-t', labelSource: 'Forrás',
      placeholderCuisine: 'pl. Brit, Olasz', placeholderServingsUnit: 'adag', placeholderIngredient: 'hozzávaló', placeholderPrepNotes: 'pl. finomra vágva', placeholderStepInstruction: 'Lépés leírása…', placeholderMins: 'perc',
      placeholderEquipment: 'Adj hozzá eszközt, majd nyomj Entert…', placeholderNotes: 'Extra tippek vagy megjegyzések…', placeholderStorage: 'pl. Hűtőben 3 napig eláll…', placeholderImageUrl: 'https://…',
      placeholderSource: "pl. BBC Good Food, Anyukám receptje, Jamie's Italy 45. o.",
      placeholderPasteText: 'Illeszd be a recept szövegét…\n\npl. Anya csokis tortája\n2 csésze liszt, 1 csésze cukor, 3 tojás…\nKeverd össze a száraz hozzávalókat…',
      placeholderTagInput: 'Írj egy címkét és nyomj Entert…',
      difficultyEasy: 'Könnyű', difficultyMedium: 'Közepes', difficultyHard: 'Nehéz',
      addIngredient: '+ Hozzávaló hozzáadása', addStep: '+ Lépés hozzáadása',
      pantryStaples: (items) => `🥄 Alapkészlet elemek észlelve: ${items} — ezek alapértelmezetten nem jelennek meg a bevásárló listán.`,
      errorTitleRequired: 'A cím megadása kötelező.', errorNetwork: 'Hálózati hiba — ellenőrizd a kapcsolatodat, és próbáld újra.', errorUrl: 'Valami hiba történt. Próbálj meg egy másik URL-t.',
      errorYoutube: 'Nem sikerült receptet kinyerni a videóból.', errorPaste: 'Nem sikerült rendszerezni a receptet. Ellenőrizd a szöveget és próbáld újra.',
      errorFileSize: 'A fájl túl nagy. Kérjük, használj 4,5 MB-nál kisebb fájlt.', errorFile: 'Nem sikerült receptet kinyerni ebből a fájlból.',
      errorDropImage: 'Kérjük, dobj ide egy képfájlt (JPEG, PNG vagy WebP).', errorDropPdf: 'Kérjük, dobj ide egy PDF fájlt.', minsLabel: 'perc',
    },
  },
};

export default translations;
